import { ScaffoldSelection } from "../../interface";

/**
 * Returns whether a specific cell is directly listed in the selectedCells list.
 *
 * @param selection - The current scaffold selection state.
 * @param rowId - The row ID of the cell to check.
 * @param colId - The column ID of the cell to check.
 * @returns True if the cell is explicitly selected.
 */
export const isCellInSelection = (
  selection: ScaffoldSelection,
  rowId: string,
  colId: string,
): boolean =>
  selection.selectedCells.some(
    (r) => r.rowId === rowId && r.colId.some((selectedColId) => selectedColId === colId),
  );
